<template>

  <!-- ############ Aside START-->
  <div id="aside" class="page-sidenav no-shrink  nav-expand  animate fadeInLeft fade" aria-hidden="true">
    <div class="sidenav h-100 modal-dialog bg-white box-shadow">
      <!-- sidenav top -->
      <!-- Flex nav content -->
      <div class="flex scrollable hover wrapper-color">
        <div class="nav-border b-primary" data-nav>
          <ul class="nav bg">
            <li class="mt-3">
              <router-link class="i-con-h-a" :to="{ name: 'DashBoard'}">
                <span class="nav-icon">
                <i class="i-con i-con-home"><i></i></i>
                </span>
                <span class="nav-text">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-header hidden-folded">
              <span>Objekte</span>
            </li>
            <li>
              <router-link class="i-con-h-a" :to="{ name: 'BookList'}">
                <span class="nav-icon">
                <i class="i-con i-con-bookmark"><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Book.books') }}</span>
              </router-link>
            </li>
            <li>
              <router-link class="i-con-h-a" :to="{ name: 'AuthorList'}">
                <span class="nav-icon">
                <i class="i-con i-con-users"><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Author.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'LawyerList'}">
                <span class="nav-icon">
                <i class="i-con i-con-users"><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Lawyer.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'PublisherList'}">
                <span class="nav-icon">
                <i class='i-con i-con-layer'><i></i></i>
                </span>
                <span class="nav-text">Verlage</span>
              </router-link>
            </li>
            <li>
              <router-link class="i-con-h-a" :to="{ name: 'CategoryList'}">
                <span class="nav-icon">
                  <i class='i-con i-con-layer'><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Category.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'Impressum'}">
                <span class="nav-icon">
                  <i class='i-con i-con-file'><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Impressum.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'Slider'}">
                <span class="nav-icon">
                  <i class='i-con i-con-video'><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Slider.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'Configuration'}">
                <span class="nav-icon">
                  <i class='i-con i-con-info'><i class="i-con-border"></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Configuration.title') }}</span>
              </router-link>
            </li>

            <li>
              <router-link class="i-con-h-a" :to="{ name: 'BackupsList'}">
                <span class="nav-icon">
                  <i class='i-con i-con-list'><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.Backups.title') }}</span>
              </router-link>
            </li>

            <li>
              <a href="#" @click.prevent="logout">
                <span class="nav-icon">
                  <i class='i-con i-con-shutdown'><i></i></i>
                </span>
                <span class="nav-text">{{ $t('message.logout') }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- sidenav bottom -->
      <div class="no-shrink wrapper-color">
        <div class="text-sm p-3 b-t">
          <div class="hidden-folded text-sm">
            <div><small class="sidebar-text-muted">by appwork</small></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ############ Aside END-->
</template>

<script>
  export default {
    name: "SideNavigation"
  }
</script>

<style scoped lang="scss">

    .i-con-h-a {
        color: #8994ab;

        &:hover {
            color: rgba(255, 255, 255, 0.8);
        }
    }

    .router-link-exact-active {
        color: rgba(255, 255, 255, 0.8);
    }

    .wrapper-color {
        background-color: #262f3c;
    }

    .sidebar-text-muted {
        color: rgba(255, 255, 255, 0.3);
    }

</style>
